export const splitModalInitValue = {
  data: {
    date: '',
    file: undefined,
    comments: '',
    notaryName: '',
    notaryProtocol: '',
    notaryCity: '',
    lastOperationDate: '',
    nominalValue: 0,
    newNominalValue: 0,
    societySharesCount: 0,
    isValidNominalValue: false,
    scriptureView: true,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeDate(): void {},
    handleChangeComments(): void {},
    handleChangeFile(): void {},
    onChangeNotaryName(): void {},
    onChangeNotaryProtocol(): void {},
    onChangeNotaryCity(): void {},
    handleChangeNewNominalValue(): void {},
    handleSaveSplit(): void {},
  },
};
